var mobile = window.matchMedia("(max-width: 992px)")

// =====================================================================
// SELF-HEALING reparent net (2026-06-14). See the debug overlay's
// "navreparent" topic for the full story. The four header elements below
// are authored inside #header-wrapper and moved INTO #main-nav on mobile
// (<992) for the hamburger menu, then back OUT to #header-wrapper on
// desktop. The desktop "move back" uses hardcoded anchors; if an anchor
// element ever stops existing — exactly how the legacy `.hi-phone` /
// `#hc-items` anchors silently broke — the element STRANDS in #main-nav at
// desktop: it inflates the brushed-steel band, and (for #header-account)
// its dropdown gets trapped UNDER the floating search.
//
// To make that class of bug impossible going forward (incl. through the
// planned MOBILE redesign): remember each element's desktop home the first
// time it is seen OUTSIDE #main-nav, then on every desktop settle force any
// element still INSIDE #main-nav back to its remembered home. This is
// anchor-INDEPENDENT, so renaming/moving a header anchor can't reintroduce
// the bug. It is a no-op once everything is correctly placed. KEEP THIS
// when reworking the header for mobile.
var JCS_REPARENTED = ['#logo', 'form#search', '#hc-items', '#header-account'];
var jcsHomes = {};
function jcsHealReparent() {
    var nav = document.getElementById('main-nav');
    JCS_REPARENTED.forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el || !el.parentNode) return;
        var inNav = nav && nav.contains(el);
        // Remember its home the first time we see it placed OUTSIDE #main-nav
        // (i.e. correctly returned to the header on a desktop settle).
        if (!jcsHomes[sel] && !inNav) {
            jcsHomes[sel] = { parent: el.parentNode, next: el.nextElementSibling };
            return;
        }
        // Still stranded in #main-nav at desktop AND we know its home → restore.
        var home = jcsHomes[sel];
        if (inNav && home && home.parent) {
            if (home.next && home.next.parentNode === home.parent) {
                home.parent.insertBefore(el, home.next);
            } else {
                home.parent.appendChild(el);
            }
        }
    });
}

$(document).ready(function() {
    $('.ui.dropdown').dropdown();

    $('.ui.message .close').on('click', function() {
        // console.log('click');
        
      $(this)
        .closest('.message')
        .transition('fade');
    });
      
    var mobile = window.matchMedia("(max-width: 992px)")
    setTimeout(() => {
        if (mobile.matches) {
            mobileFunction(mobile)
            mobile.addListener(mobileFunction)
        } 
    }, 1000);
    
    mobileFunction(mobile) // Call listener function at run time
    mobile.addListener(mobileFunction) // Attach listener function on state changes
}); // END READY

window.onload = function(){
    setTimeout(function() {
        if (false && $(window).width() < 992) { // mobile reparent disabled — the nav is now an inline menu bar, so logo / search / account stay in the header (mobile-responsive-build)
            $('#logo').insertAfter('#main-nav .navbar-toggler'); 
            $('form#search').insertAfter('#main-nav .navbar-nav'); 
            $('#hc-items').insertAfter('#main-nav #logo'); 
            $('#header-account').insertAfter('#main-nav #logo'); 
        } else {
            $('#logo').prependTo('#header-wrapper .logo-cont'); 
            // Search form moved to floating #header-search overlay on the
            // breadcrumb row (was '#header-wrapper .search-cont').
            $('form#search').prependTo('#header-search'); 
            // See Resize(): return #header-account to its real home,
            // #header-wrapper .header-utility-row (.hi-phone / #hc-items no
            // longer exist in the markup, so the old anchors stranded it).
            $('#header-account').appendTo('#header-wrapper .header-utility-row');
            jcsHealReparent(); // record desktop homes + restore anything still stuck in #main-nav
        }
    }, 1000);
    
        mobileFunction(mobile)
        mobile.addListener(mobileFunction)
    
}

// Debounce the resize-driven reparent so it runs on the SETTLED width, not on
// the transient mid-reflow widths a continuous resize fires (docking/undocking
// dev tools, window drags). The old un-debounced handler could read a sub-992
// width during a widen-back and re-stuff #logo/#header-account/#hc-items/#search
// INTO #main-nav, leaving them stuck there at desktop — which inflated the
// perforated-steel nav band (~42px -> ~69px) and showed a duplicate logo until
// a page refresh. Re-running once the width has settled reparents them back to
// #header-wrapper reliably. (A CSS safety net in steele-consistency-fix.css
// also neutralizes any residual stuck element so the bar can't inflate.)
var _jcsReparentT;
$(window).resize(function () {
    clearTimeout(_jcsReparentT);
    _jcsReparentT = setTimeout(Resize, 200);
});

function Resize() {
    if (false && $(window).width() < 992) { // mobile reparent disabled — the nav is now an inline menu bar, so logo / search / account stay in the header (mobile-responsive-build)
        $('#logo').insertAfter('#main-nav .navbar-toggler'); 
        $('form#search').insertAfter('#main-nav .navbar-nav'); 
        $('#hc-items').insertAfter('#main-nav #logo'); 
        $('#header-account').insertAfter('#main-nav #logo'); 
    } else {
        $('#logo').prependTo('#header-wrapper .logo-cont'); 
        // Search form moved to floating #header-search overlay on the
        // breadcrumb row (was '#header-wrapper .search-cont').
        $('form#search').prependTo('#header-search'); 
        // Return #header-account to its REAL markup home: #header-wrapper
        // .header-utility-row (inside .account-cont — see Head.vue). The old
        // anchors `.hi-phone` / `#hc-items` DO NOT EXIST in the current markup
        // (legacy from an earlier header), so the desktop "move back" silently
        // no-op'd and #header-account stayed STRANDED in #main-nav after any
        // sub-992 excursion (e.g. docking dev-tools) — mispositioned, and its
        // My Account dropdown trapped UNDER the floating search. .header-utility-
        // row is its sole original child slot, so appendTo cleanly restores it.
        $('#header-account').appendTo('#header-wrapper .header-utility-row');
        jcsHealReparent(); // record desktop homes + restore anything still stuck in #main-nav
    }
}

function mobileFunction() {
    if (false && mobile.matches) { // mobile reparent disabled — inline nav bar now (see above)
        $('#logo').insertAfter('#main-nav .navbar-toggler'); 
        $('form#search').insertAfter('#main-nav .navbar-nav'); 
        $('#hc-items').insertAfter('#main-nav #logo'); 
        $('#header-account').insertAfter('#main-nav #logo'); 
    } else {
        $('#logo').prependTo('#header-wrapper .logo-cont'); 
        // Search form moved to floating #header-search overlay on the
        // breadcrumb row (was '#header-wrapper .search-cont').
        $('form#search').prependTo('#header-search'); 
        // Return #header-account to its REAL markup home: #header-wrapper
        // .header-utility-row (inside .account-cont — see Head.vue). The old
        // anchors `.hi-phone` / `#hc-items` DO NOT EXIST in the current markup
        // (legacy from an earlier header), so the desktop "move back" silently
        // no-op'd and #header-account stayed STRANDED in #main-nav after any
        // sub-992 excursion (e.g. docking dev-tools) — mispositioned, and its
        // My Account dropdown trapped UNDER the floating search. .header-utility-
        // row is its sole original child slot, so appendTo cleanly restores it.
        $('#header-account').appendTo('#header-wrapper .header-utility-row');
        jcsHealReparent(); // record desktop homes + restore anything still stuck in #main-nav
    }
}